





































































































































































































































































































































































































































































































































































































































































































import {Component, Vue} from "vue-property-decorator";
import _ from "lodash";
import Company from "@/model/company";
import QUserSelect from "@/common/qUserSelect.vue";
import QCalendar from "@/common/qCalendar.vue";
import QTableHeader from "@/common/qTableHeader.vue";
import QErrors from "@/common/qErrors.vue";
import QPropertySelect from "@/common/qPropertySelect.vue";
import QPaginate from "@/common/qPaginate.vue";
import {namespace} from "vuex-class";
import Contract, {CONTRACT_SEND_MAIL_STATUS, CONTRACT_STATUS} from "@/model/contract";
import contractApi from "@/api/contractApi";
import VueUploadComponent from "vue-upload-component";
import fileApi from "@/api/fileApi";
import qNotify from "@/common/qNotify";
import CustomerSearch from "@/components/contract/customerSearch.vue";
import ContractActiveLog from "@/components/contract/contractActiveLog.vue";
import moment from "moment";
import User, {USER_ROLE} from "@/model/user";
import { DATE_FORMAT } from "@/common/constant";
import {compareWithKeys} from "@/common/utils";
// eslint-disable-next-line @typescript-eslint/no-var-requires
var noimage = require("@/assets/images/muuq-base/noimage.png");
const auth = namespace("Auth");;
const routerStore = namespace("Router");
@Component({
  name: "ContractEdit",
  components: {
    QUserSelect,
    QCalendar,
    QTableHeader,
    QPaginate,
    VueUploadComponent,
    QPropertySelect,
    QErrors,
    CustomerSearch,
    ContractActiveLog,
  },
})
export default class ContractEdit extends Vue {
  @auth.Getter
  getCurrentyCompany!: Company;
  @auth.Getter
  getUserLogging!: User;
  @routerStore.Getter
  public getSearchParameters!:any;

  public isShow = false;
  public errors = {};
  public files = [];
  public isWork = false;
  public isClosed = false;
  public isMoveOut = false;
  public today = null;
  public showPopupEmail = false;
  public userRole = USER_ROLE;

  public contractObject: Contract = new Contract();
  public contractObjectInit: Contract = new Contract();
  public contractObjectClone: Contract = new Contract();
  public dateConfig = {};

  get isEdit() {
    return this.$router.currentRoute.name === "admin.contract-edit";
  }

  get showStatus() {
    if (this.contractObject.move_in_date) {
      return (moment(this.contractObject.move_in_date).isSameOrAfter(moment(this.today).format(DATE_FORMAT)));
    }
    return true;
  }

  get showSendMailButton() {
    if (this.contractObject.move_in_date) {
      return !((moment(this.contractObject.move_in_date).isSameOrAfter(moment(this.today).format(DATE_FORMAT)))
          && (this.contractObject.status === CONTRACT_STATUS.WAIT));
    }

    return (this.contractObject.status === CONTRACT_STATUS.CONFIRM);
  }

  get contractId() {
    return this.$router.currentRoute.params.id;
  }

  get submitText() {
    return this.contractObject.status === CONTRACT_STATUS.CONFIRM
      ? "保存"
      : "招待";
  }

  get companyId() {
    return this.getCurrentyCompany.id;
  }

  get imageUrl() {
    return this.contractObject.image ? this.contractObject.image.url : noimage;
  }

  get hasImage() {
    return this.contractObject.image_id;
  }

  async mounted() {
    this.today = moment();
    this.contractObject.contractor_id = this.getUserLogging.id;
    this.contractObjectInit = _.cloneDeep(this.contractObject)
    if (this.isEdit) {
      this.detail();
    }
  }

  public async detail() {
    const result = await contractApi.detail(this.contractId);
    if (result) {
      this.contractObject = result;
      this.contractObjectClone = _.clone(result);
      this.isWork = this.contractObject.status != CONTRACT_STATUS.CLOSE;
      this.isClosed = this.contractObject.status === CONTRACT_STATUS.CLOSE;
      this.isMoveOut = this.contractObject.count_contract_move_outs > 0;
    }
    this.contractObjectInit = _.cloneDeep(this.contractObjectClone)
  }

  public changeMoveInDate() {
    if (!this.showStatus) {
      this.contractObject.status = CONTRACT_STATUS.WAIT;
    }
  }

  public inputFilter(newFile, oldFile, prevent) {
    if (newFile && !oldFile && !/\.(pdf)$/i.test(newFile.name)) {
      return prevent();
    }
  }

  public inputFile(newFile) {
    this.handleFileUpload(newFile.map((item) => item.file));
    this.files = [];
  }
  public async handleFileUploadImage(event) {
    let file = event.target.files[0];
    if (!file) {
      return;
    }

    this.errors["image"] = [];
    this.errors["image_id"] = [];

    let formData = new FormData();
    formData.append("image", file);
    formData.append("image_type", "Contract");
    const result = await fileApi.uploadImage(formData);
    if (result.meta.status != 200) {
      qNotify.error({
        text: this.$t(result.meta.message),
      });
      this.errors = { ...this.errors, ...result.meta.errors };
    } else {
      this.contractObject.image_id = result.data.id;
      this.contractObject.image = result.data;
    }
  }

  public async handleFileUpload(files) {
    if (files.length === 0) {
      return;
    }
    delete this.errors["file_errors"];
    const requestUploads = [];
    for (const file of files) {
      let formData = new FormData();
      formData.append("file", file);
      formData.append("file_type", "Contract");
      requestUploads.push(fileApi.uploadFile(formData));
    }
    const results = await Promise.all(requestUploads);
    let index = 0;
    // this.errors['files'] = [];
    const errorMessage = [];
    for (const result of results) {
      if (result.meta.status === 200) {
        // this.repairContent[fileOf].push(result.data);
        this.contractObject.addFile(result.data);
      } else {
        errorMessage.push(
          this.$t("upload.max_size", { filename: files[index].name })
        );
      }
      index++;
    }
    errorMessage.length > 0 &&
      (this.errors = { ...this.errors, file_errors: errorMessage });
  }

  public onChangeFile() {
    this.handleFileUpload((this.$refs.fileBefore as any).files);
  }
  public checkPass() {
    if (this.contractObject.exists_account == 1 && !this.validatePassword(this.contractObject.j_sys.password)) {
      qNotify.error({
        text: "アカウントが作成できませんでした。",
      });
      return false;
    } else if (
      this.contractObject.exists_account == 1 &&
      this.contractObject.j_sys.password !==
        this.contractObject.j_sys.re_password
    ) {
      qNotify.error({
        text: "アカウントが作成できませんでした。",
      });
      this.errors = {
        ...this.errors,
        "j_sys.re_password": [this.$t("users.wrong_re_password")],
      };
      return false;
    }
    return true;
  }
  public isChangeToConfirm() {
    if (this.contractObject.id) {
      return (
        (this.contractObject.status == CONTRACT_STATUS.CONFIRM &&
          this.contractObject.j_sys_id != this.contractObjectClone.j_sys_id) ||
        (this.contractObject.status == CONTRACT_STATUS.CONFIRM &&
          this.contractObjectClone.status == CONTRACT_STATUS.WAIT)
      );
    } else {
      return this.contractObject.status == CONTRACT_STATUS.CONFIRM;
    }
  }
  public async submit(isSendMail: boolean) {
    if (!this.checkPass()) {
      return;
    }
    this.errors = {};
    this.contractObject.is_send_mail = (isSendMail) ? CONTRACT_SEND_MAIL_STATUS.YES : CONTRACT_SEND_MAIL_STATUS.NO;
    const result = await this.contractObject.save();

    if (result.meta.status === 200) {
      if (this.contractObject.j_sys_id && this.isChangeToConfirm() && isSendMail) {
        // show popup
        this.showPopupEmail = true;
      } else {
        qNotify.success({
          text: this.contractObject.id
            ? this.$t("contracts.created")
            : this.$t("contracts.updated"),
        });
        this.$router.push({ name: "admin.contract" , query: this.getSearchParameters ? this.getSearchParameters.contractList : null });
      }
    } else {
      qNotify.error({
        text: "契約者情報作成できませんでした。",
      });
      this.errors = result.meta.errors;
    }
  }

  public removeImage() {
    this.contractObject.image_id = null;
    this.contractObject.image = null;
  }

  public async remove() {
    this.$modal.showDelete({
      text: "削除を実行します。この操作は取り消せません。",
      // we are passing callback method for our confirm button
      onConfirm: async () => {
        const result = await this.contractObject.remove();

        if (result.meta.status === 200) {
          qNotify.success({
            text: this.$t("contracts.deleted"),
          });
          this.$router.push({ name: "admin.contract" , query: this.getSearchParameters ? this.getSearchParameters.contractList : null });
        } else {
          qNotify.error({
            text: result.meta.message,
          });
        }
      },
      onClose: () => {
        console.log("onClose");
      },
    });
  }

  public cancel() {
    if (this.isChanged()) {
      this.$modal.showCancel({
        text: this.$t("cancel"),
        // we are passing callback method for our confirm button
        onConfirm: () => {
          this.$router.push({ name: "admin.contract" , query: this.getSearchParameters ? this.getSearchParameters.contractList : null });
        },
        onClose: () => {
          console.log("onClose");
        },
      });
    } else {
      this.$router.push({ name: "admin.contract" , query: this.getSearchParameters ? this.getSearchParameters.contractList : null });
    }
  }

  public searchCustomer() {
    (this.$refs.customerSearchRef as CustomerSearch).show();
  }

  public keyNumberOnly(event) {
    console.log(event);
    event.target.value = event.target.value.replace(/\d/g, "");
  }

  public validatePassword(value) {
    if (!/^[\dA-Za-z]*$/.test(value)) {
      this.errors = {
        ...this.errors,
        "j_sys.password": [this.$t("users.regex_password")],
      };
      return false;
    } else {
      this.errors["j_sys.password"] = [];
      return true;
    }
  }

  public isChanged() {
    if (this.contractObject.returned_items.length !== this.contractObjectInit.returned_items.length) {
      return true;
    } else if (this.contractObject.files.length !== this.contractObjectInit.files.length) {
      return true;
    } else {
      for (let key in this.contractObjectInit.addition_items) {
        const isChange = compareWithKeys(this.contractObject.addition_items[key], this.contractObjectInit.addition_items[key], [
          'name',
          'value',
        ])
        if (isChange === false) {
          continue;
        }
        return true;
      }

      return compareWithKeys(this.contractObject, this.contractObjectInit, [
        'contractor_id',
        'type',
        'no',
        'move_in_date',
        'contractor_name',
        'contractor_name2',
        'contractor_phone',
        'resident_name',
        'resident_name2',
        'resident_phone',
        'exists_account',
        'j_sys_id',
        'bank_account_information',
        'property_id',
        'image_id',
        'security_deposit',
        'rent',
        'common_service_fee',
        'town_membership_fee',
        'deposit',
        'depreciation',
        'status',
        'withdrawal_application',
      ])
    }
  }
}
